import { addLocale } from "primereact/api";

import * as primeReactLocaleFr from "../../../assets/prime-react-locales/locale-fr.json";

export function addPrimeReactLocales() {
  addLocale("fr", primeReactLocaleFr);
}
